import React from "react";
import Globals from "../../api";
import ReactHtmlParser from "react-html-parser";

export default class commonPages extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      commonContents: [],
    };
  }

  componentDidMount() {
    const commonPageData = Globals.common_contents;
    fetch(commonPageData)
      .then((res) => res.json())
      .then((data) => {
        this.setState({
          commonContents: data.FooterLinks.Items,
        });
      });
  }

  render() {
    let url = window.location.pathname;
    let pageContents = this.state.commonContents.filter(
      (x) => x.DefaultUrl == `${url}`
    );
    
    {
      var DataItems = pageContents.map((item) => {
        var htmlContent = item.Pagehtml;
        return ReactHtmlParser(htmlContent);
      });
    }
    if (url == "/contact-us")
    {
      var ContactHtml = '<div class="container m-b-20 contactus_page"><div class="page_title"><h1>మమ్మల్ని సంప్రదించండి - </h1></div><h4>Thank You for visiting our site. We value our users and would be happy to hear from you. Please connect with     us in case of any queries, concerns or for any kind of feedbacks.</h4> <div class="contact_us_block1"> <p>ವೆಬ್‌ದುನಿಯಾ ಪೋರ್ಟಲ್‌ನಲ್ಲಿ ಪ್ರಕಾಶಿತಗೊಂಡ ಯಾವುದೇ ಸುದ್ದಿಯ ಬಗ್ಗೆ ಅಥವಾ ಯಾವುದೇ ಮಾಹಿತಿಯನ್ನು ಪಡೆಯಲು <a href="mailto:editorial@webdunia.net" title="email"> editorial@webdunia.net </a> ಗೆ ಇ-ಮೇಲ್‌ ಮಾಡಿ ಅಥವಾ ಕೆಳಗಿನ ವಿಳಾಸಕ್ಕೆ ಕೂಡಾ ಮಾಹಿತಿ ನೀಡಬಹುದು. </p> <hr/>  <p>For any Content published on Webdunia.com or to get any information you can email to us on editorial@webdunia.net or You can also write to us : </p>  </div><div class="contact_us_block2"> <p>"संपादकीय विभाग" वेबदुनिया.कॉम (इंडिया) प्रा. लि. "लाभ-गंगा", 582 महात्मा गांधी मार्ग, इंदौर - 452003 [भारत]</p> <p><b>दूरभाष :</b>+91-731-4273409 | <b>फैक्स :</b>+91-731-254-8555</p>    <hr/>   <p>Webdunia.com (India) Pvt Ltd (CMMI 3)  "Labh Ganga", 582 MG Road,    Indore - 452003 MP [India]     </p>   <p><b>Contact :</b>+91-731-4273409 | <b>Fax :</b>+91-731-254-8555</p>     </div>  <div class="clearfix"></div>		 <p><b>నిరాకరణ:</b>: ఆక్షేపణీయమైన, ఉల్లంఘనీయమైన, అశ్లీలమైన, అసభ్యమైన, వివక్షపూరితమైనటువంటి లేదా చట్టవ్యతిరేకమైన అంశాలు లేదా సమాచారాన్ని దయచేసి జోడించవద్దు. వినియోగదారుడు/పాఠకుని నుంచి వచ్చే ఎలాంటి విషయం లేదా సమాచారాన్నయినా ఎలాంటి సూచన లేకుండానే తొలగించే హక్కును Webdunia.com (India) Pvt Ltd  కలిగి ఉంది. </p>  <p><b>Disclaimer</b>: Kindly do not post any defamatory, infringing, obscene, indecent, discriminatory or unlawful material or information. Webdunia.com (India) Pvt Ltd reserves the right to remove any content received from users/readers without notice.</p> <p><b>To advertise on Webdunia network sites/app, click <a href="/advertise-with-us">Advertise with Us</a> </b></p>  <p><b>To know more about Webdunia , click <a href="/about-us">About Us</a></b></p> </div>';
      DataItems = ReactHtmlParser(ContactHtml);
    }
    return <div className="container padding15">{DataItems}</div>;
  }
}
